import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RatingStar = _resolveComponent("RatingStar")!
  const _component_RatingNumber = _resolveComponent("RatingNumber")!

  return ($setup.ratingTemplate.type === $setup.RATING_TEMPLATE_TYPE.STAR)
    ? (_openBlock(), _createBlock(_component_RatingStar, {
        key: 0,
        ratingTemplate: $setup.ratingTemplate,
        onSendMessage: $setup.sendCustomMessage
      }, null, 8, ["ratingTemplate", "onSendMessage"]))
    : (_openBlock(), _createBlock(_component_RatingNumber, {
        key: 1,
        ratingTemplate: $setup.ratingTemplate,
        onSendMessage: $setup.sendCustomMessage
      }, null, 8, ["ratingTemplate", "onSendMessage"]))
}